import React, { useState, useRef, useEffect } from "react";
import TextFilter from "../UserFilter/TextFilter";
import SelectFilter from "../UserFilter/SelectFilter";
import { DateRangePicker } from "react-date-range";
import { format, startOfMonth, endOfMonth, subDays, subMonths } from "date-fns";
import { vi } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

export const staticRanges = [
  {
    label: "Hôm nay",
    range: () => ({
      startDate: new Date(),
      endDate: new Date(),
    }),
    isSelected: (range) => {
      const today = new Date().toDateString();
      return (
        range.startDate?.toDateString() === today &&
        range.endDate?.toDateString() === today
      );
    },
  },
  {
    label: "Hôm qua",
    range: () => {
      const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      return { startDate: yesterday, endDate: yesterday };
    },
    isSelected: (range) => {
      const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      return (
        range.startDate?.toDateString() === yesterday.toDateString() &&
        range.endDate?.toDateString() === yesterday.toDateString()
      );
    },
  },
  {
    label: "7 ngày qua",
    range: () => {
      const start = new Date(new Date().setDate(new Date().getDate() - 6));
      const end = new Date();
      return { startDate: start, endDate: end };
    },
    isSelected: (range) => {
      const start = new Date(new Date().setDate(new Date().getDate() - 6));
      const end = new Date();
      return (
        range.startDate?.toDateString() === start.toDateString() &&
        range.endDate?.toDateString() === end.toDateString()
      );
    },
  },
  {
    label: "30 ngày qua",
    range: () => {
      const start = new Date(new Date().setDate(new Date().getDate() - 29));
      const end = new Date();
      return { startDate: start, endDate: end };
    },
    isSelected: (range) => {
      const start = new Date(new Date().setDate(new Date().getDate() - 29));
      const end = new Date();
      return (
        range.startDate?.toDateString() === start.toDateString() &&
        range.endDate?.toDateString() === end.toDateString()
      );
    },
  },
  {
    label: "Tháng này",
    range: () => {
      const start = startOfMonth(new Date());
      const end = new Date();
      return { startDate: start, endDate: end };
    },
    isSelected: (range) => {
      const start = startOfMonth(new Date());
      const end = new Date();
      return (
        range.startDate?.toDateString() === start.toDateString() &&
        range.endDate?.toDateString() === end.toDateString()
      );
    },
  },
  {
    label: "Tháng trước",
    range: () => {
      const prevMonth = subMonths(new Date(), 1);
      const start = new Date(prevMonth.getFullYear(), prevMonth.getMonth(), 1);
      const end = new Date(
        prevMonth.getFullYear(),
        prevMonth.getMonth() + 1,
        0
      );
      return { startDate: start, endDate: end };
    },
    isSelected: (range) => {
      const prevMonth = subMonths(new Date(), 1);
      const start = new Date(prevMonth.getFullYear(), prevMonth.getMonth(), 1);
      const end = new Date(
        prevMonth.getFullYear(),
        prevMonth.getMonth() + 1,
        0
      );
      return (
        range.startDate?.toDateString() === start.toDateString() &&
        range.endDate?.toDateString() === end.toDateString()
      );
    },
  },
];
const UserFilters = ({ filter, handleFilterChange, setFilter }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [datePickerType, setDatePickerType] = useState(null);
  const datePickerRef = useRef(null);
  const buttonRef = useRef(null);

  // Đóng picker khi click ra ngoài
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const loginStatusOptions = [
    { value: "", label: "Tất cả" },
    { value: "loggedIn", label: "Đã đăng nhập" },
    { value: "notLoggedIn", label: "Chưa đăng nhập" },
  ];

  const formatDateRange = (startDate, endDate) => {
    if (!startDate || !endDate) return "Chọn khoảng thời gian";
    return `${format(new Date(startDate), "dd/MM/yyyy", {
      locale: vi,
    })} - ${format(new Date(endDate), "dd/MM/yyyy", { locale: vi })}`;
  };

  const handleDateRangeSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    if (datePickerType === "createdAt") {
      setFilter((prev) => ({
        ...prev,
        createdAtFrom: startDate
          ? format(startDate, "yyyy-MM-dd'T'00:00:00")
          : "",
        createdAtTo: endDate ? format(endDate, "yyyy-MM-dd'T'23:59:59") : "",
      }));
    } else if (datePickerType === "firstLogin") {
      setFilter((prev) => ({
        ...prev,
        firstLoginAtFrom: startDate
          ? format(startDate, "yyyy-MM-dd'T'00:00:00")
          : "",
        firstLoginAtTo: endDate ? format(endDate, "yyyy-MM-dd'T'23:59:59") : "",
      }));
    } else if (datePickerType === "datePost") {
      setFilter((prev) => ({
        ...prev,
        datePostAtFrom: startDate
          ? format(startDate, "yyyy-MM-dd'T'00:00:00")
          : "",
        datePostAtTo: endDate ? format(endDate, "yyyy-MM-dd'T'23:59:59") : "",
      }));
    } else if (datePickerType === "lastLogin") {
      setFilter((prev) => ({
        ...prev,
        lastLoginAtFrom: startDate
          ? format(startDate, "yyyy-MM-dd'T'00:00:00")
          : "",
        lastLoginAtTo: endDate ? format(endDate, "yyyy-MM-dd'T'23:59:59") : "",
      }));
    }
    setShowDatePicker(false);
  };

  // Custom staticRanges + isSelected cho mỗi mục

  const DateRangeButton = ({ type, label, startDate, endDate }) => {
    const selectionRange = {
      startDate: startDate ? new Date(startDate) : null,
      endDate: endDate ? new Date(endDate) : null,
      key: "selection",
    };

    return (
      <div className="relative">
        <button
          ref={buttonRef}
          type="button"
          onClick={() => {
            if (datePickerType === type && showDatePicker) {
              setShowDatePicker(false);
            } else {
              setDatePickerType(type);
              setShowDatePicker(true);
            }
          }}
          className="w-full border rounded-lg p-2.5 pl-4 text-left bg-white dark:bg-gray-700 dark:text-white hover:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {formatDateRange(startDate, endDate)}
        </button>
        {showDatePicker && datePickerType === type && (
          <div
            ref={datePickerRef}
            className="absolute z-50 mt-1 bg-white dark:bg-gray-800 shadow-lg rounded-lg border border-gray-200 dark:border-gray-700"
            style={{ minWidth: "600px" }}
          >
            {/* Chèn CSS override ngay trong JSX để ép luôn picker thành light theme */}
            <style>
              {`
                /* Ép background của calendar luôn trắng */
                .rdrCalendarWrapper, 
                .rdrMonthAndYearWrapper, 
                .rdrDateDisplayWrapper, 
                .rdrMonthPicker, 
                .rdrYearPicker {
                  background: white !important;
                  color: #111 !important;
                }
                .rdrDefinedRangesWrapper, 
                .rdrStaticRange, 
                .rdrStaticRangeLabel {
                  background: white !important;
                  color: #111 !important;
                }
                /* Border và hover */
                .rdrDefinedRangesWrapper {
                  border-right: 1px solid #e5e7eb !important; /* gray-200 */
                }
                .rdrStaticRange:hover {
                  background: #f3f4f6 !important; /* gray-100 */
                }
                .rdrStaticRangeSelected {
                  background: #3b82f6 !important; /* blue-500 */
                }
                .rdrStaticRangeSelected .rdrStaticRangeLabel {
                  color: white !important;
                }
                /* Ngày trong calendar */
                .rdrDayNumber {
                  color: #111 !important;
                }
                .rdrDayToday .rdrDayNumber span:after {
                  background: #3b82f6 !important;
                }
                .rdrInRange, 
                .rdrStartEdge, 
                .rdrEndEdge {
                  background: #3b82f6 !important;
                }
                .rdrDayHovered {
                  border-color: #3b82f6 !important;
                }
              `}
            </style>

            <DateRangePicker
              onChange={handleDateRangeSelect}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              direction="horizontal"
              locale={vi}
              rangeColors={["#3B82F6"]}
              showDateDisplay={false}
              staticRanges={staticRanges}
              inputRanges={[]}
              ranges={[selectionRange]}
            />
          </div>
        )}
        <span className="absolute -top-2 left-2 text-xs bg-white dark:bg-gray-900 px-1">
          {label}
        </span>
      </div>
    );
  };

  return (
    <div className="w-2/3 grid grid-cols-3 gap-4">
      <div className="relative">
        <input
          type="text"
          name="id"
          placeholder="ID Khách hàng"
          value={filter.id}
          onChange={handleFilterChange}
          className="w-full border rounded-lg p-2.5 pl-4 dark:bg-gray-700 dark:text-white"
        />
      </div>
      <div className="relative">
        <input
          type="text"
          name="code"
          placeholder="Mã Khách hàng"
          value={filter.code}
          onChange={handleFilterChange}
          className="w-full border rounded-lg p-2.5 pl-4 dark:bg-gray-700 dark:text-white"
        />
      </div>
      <div className="relative">
        <input
          type="text"
          name="firstName"
          placeholder="Tên"
          value={filter.firstName}
          onChange={handleFilterChange}
          className="w-full border rounded-lg p-2.5 pl-4 dark:bg-gray-700 dark:text-white"
        />
      </div>

      <DateRangeButton
        type="createdAt"
        label="Ngày tạo tài khoản"
        startDate={filter.createdAtFrom}
        endDate={filter.createdAtTo}
      />

      <DateRangeButton
        type="datePost"
        label="Ngày đăng bài"
        startDate={filter.datePostAtFrom}
        endDate={filter.datePostAtTo}
      />

      <div className="relative">
        <select
          name="loginStatus"
          value={filter.loginStatus}
          onChange={handleFilterChange}
          className="w-full border rounded-lg p-2.5 pl-4 dark:bg-gray-700 dark:text-white appearance-none"
        >
          {loginStatusOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="absolute -top-2 left-2 text-xs bg-white dark:bg-gray-900 px-1">
          Trạng thái
        </span>
      </div>

      <div className="relative">
        <input
          type="text"
          name="phoneNumber"
          placeholder="Số điện thoại"
          value={filter.phoneNumber}
          onChange={handleFilterChange}
          className="w-full border rounded-lg p-2.5 pl-4 dark:bg-gray-700 dark:text-white"
        />
      </div>

      <DateRangeButton
        type="firstLogin"
        label="Ngày đăng nhập lần đầu"
        startDate={filter.firstLoginAtFrom}
        endDate={filter.firstLoginAtTo}
      />

      <DateRangeButton
        type="lastLogin"
        label="Đăng nhập lần cuối"
        startDate={filter.lastLoginAtFrom}
        endDate={filter.lastLoginAtTo}
      />
    </div>
  );
};

export default UserFilters;
